import UserPreferenceSingleton from '../helpers/userPreferenceSingleton';
import LocalDbService, { FILES_TABLE_NAME, UPDATE_ON_ID } from './localDbService';
import { ProjectFilesInterface } from '../interfaces/ProjectInterface';

interface FilesCacheServiceProps {
  organizationId: string;
  dbName?: string;
  tableName?: string;
}

interface FileDbRow {
  id: string;
  tableId: string;
  value: {
    id: string;
    value: ProjectFilesInterface[];
  };
}

let singleton: FilesCacheService | undefined;
let organizationId: string | undefined;

export default class FilesCacheService extends LocalDbService {
  constructor(props: FilesCacheServiceProps) {
    const db_name = `${props.organizationId}`;
    props.dbName = db_name;
    props.tableName = FILES_TABLE_NAME;
    super(props);
  }

  static getInstance() {
    const company = UserPreferenceSingleton.getInstance().getWorkspace();
    if (company) {
      if (!singleton || organizationId !== company?.id) {
        organizationId = company?.id;
        singleton = new FilesCacheService({ organizationId: company?.id });
      }
    }
    return singleton;
  }

  static removeInstance() {
    if (singleton) singleton.closeDb();
    organizationId = undefined;
    singleton = undefined;
  }

  // async getFiles() {
  //     const result = await this.get();
  //     return result;
  // }

  async getFilesByTable(tableId: string): Promise<Array<{ id: string; value: ProjectFilesInterface[] }>> {
    if (tableId && this.db) {
      const rows: FileDbRow[] = await this.getDb().where('tableId').equals(tableId).toArray();
      const result = rows?.map((x) => x?.value);
      return result;
    }
    return [];
  }

  async getFilesByTableIds(tableIds: string[]): Promise<Array<{ id: string; value: ProjectFilesInterface[] }>> {
    if (tableIds && tableIds.length > 0 && this.db) {
      const rows: FileDbRow[] = await this.getDb().where('tableId').anyOf(tableIds).toArray();
      const result = rows.map((x) => x.value);
      return result;
    }
    return [];
  }

  async setFiles(projectId: string, value: ProjectFilesInterface[], companyId: string) {
    if (!value || companyId !== organizationId) return false;
    const filesData = [
      {
        id: projectId,
        value: value
      }
    ];
    const result = await this.addBulk(filesData);
    return result;
  }

  async updateFiles(newList: ProjectFilesInterface[], archivedList: string[], companyId: string) {
    if (companyId !== organizationId) return false;
    await this.syncList(newList, archivedList);
  }

  async updateProjectFiles(data: ProjectFilesInterface[], archived: ProjectFilesInterface[], projectId: string) {
    if (!projectId) return;
    const projectFiles = await this.getItem(projectId);
    let fieldValueOnly: ProjectFilesInterface[] = projectFiles?.value;

    if (data?.length > 0) {
      data?.forEach((item) => {
        let status = false;
        fieldValueOnly = fieldValueOnly?.map((x) => {
          if (x?.id === item?.id) {
            status = true;
            return item;
          } else return x;
        });
        if (!status) {
          fieldValueOnly = [...(fieldValueOnly || []), item];
        }
      });
    }
    if (archived?.length > 0) {
      archived?.forEach((item) => {
        const dataIndex = fieldValueOnly?.findIndex((x) => x?.id === item?.id);
        if (dataIndex !== -1) {
          fieldValueOnly?.splice(dataIndex, 1);
        }
      });
    }
    const fileFields = [
      {
        id: projectId,
        value: fieldValueOnly
      }
    ];
    const result = await this.addBulk(fileFields);
    return result;
  }

  async getLastUpdatedTime(projectId?: string) {
    const result = await super.getLastUpdatedTime(`${UPDATE_ON_ID.FILES}_${projectId}`);
    return result;
  }

  async setLastUpdatedTime(value: string, companyId: string, projectId?: string) {
    if (companyId !== organizationId) return false;
    const result = await super.setLastUpdatedTime(`${UPDATE_ON_ID.FILES}_${projectId}`, value);
    return result;
  }
}
